module.exports = __webpack_public_path__ + "img/info1V2H5.f2e76c36.png";